<template>
  <div v-if="show" class="loading-container">
    <div class="content">
      <div class="logo-wrapper">
        <div class="rotating-logo">
          <img src="/images/logo.webp" alt="Al-Furqan Logo" class="logo" />
        </div>
        <span class="logo-text">Al-Furqan Academy</span>
      </div>
      <div class="fancy-loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p class="loading-text">Preparing your experience...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingView",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.loading-container {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    -45deg,
    var(--background),
    var(--button),
    var(--heading)
  );
  background-size: 400% 400%;
  animation: gradient 6s ease infinite;
  color: #fff;
}

.content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;

  .logo {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 50%; // ✅ تخلي الصورة دائرية
    animation: spin360 2s ease-in-out infinite;
    animation-delay: 1s;
  }

  .logo-text {
    margin-top: 10px;
    font-size: 1.2rem;
    font-weight: 600;
    opacity: 0.85;
    letter-spacing: 1px;
  }
}

.fancy-loader {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;

  span {
    display: block;
    width: 12px;
    height: 12px;
    background: #fff;
    border-radius: 50%;
    animation: bounce 0.6s infinite alternate;
  }

  span:nth-child(2) {
    animation-delay: 0.2s;
  }

  span:nth-child(3) {
    animation-delay: 0.4s;
  }

  span:nth-child(4) {
    animation-delay: 0.6s;
  }
}

.loading-text {
  font-size: 1.2rem;
  font-weight: 500;
  animation: fadeIn 1.5s ease-in-out infinite alternate;
  opacity: 0.8;
}

/* Animations */
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes spin360 {
  0% {
    transform: rotate(0deg);
  }
  90% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes bounce {
  to {
    transform: translateY(-10px);
    opacity: 0.7;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
</style>
